export function getFormatters(config: { allowNegative?: boolean; allowDecimal?: boolean }): {
  formatModel(model: string): string;
  formatInput(input: string): string;
} {
  const regexFormatModel = new RegExp(
    `^[^\\d.,-]*?(${config?.allowNegative ? `-(?!\\D*$${config.allowDecimal ? '' : '|\\D*\\.'})` : ''})?[^\\d.,]*([\\d,]*)[^.]*(?:${config?.allowDecimal ? '(\\.(?!\\D*$))[^\\d]*(\\d*)' : ''})?.*$|.*`
  );
  function formatModel(model: string) {
    return model
      .replace(regexFormatModel, config?.allowDecimal ? '$1$2$3$4' : '$1$2')
      .replaceAll(',', '');
  }

  const regexFormatInput = new RegExp(
    `^[^\\d\\-.]*(${config?.allowNegative ? '-?' : ''}\\d*${config?.allowDecimal ? '\\.?\\d*' : ''}).*$|.*`
  );
  function formatInput(input: string) {
    return input.replace(regexFormatInput, '$1');
  }

  return { formatModel, formatInput };
}
